<bp-tile class="card" color="default" [padding]="false" [title]="!isLimOrdEnabled ? 'Watchlist' : ''">
  @if (vm?.list?.length > 0) {
    <a
      class="button-weight btn_manage"
      tile-actions
      [tabIndex]="0"
      (click)="openWatchlist()">
      {{ "dashboard_watchlist_manage" | translate }}
    </a>
  }
  <watchlist-widget-list [list]="vm.list"> </watchlist-widget-list>
  <!-- Performance Indicators needed for UK -->
	<performance-indicators-notification [classes]="['hasPadding', 'hasBorderBottom']"></performance-indicators-notification>
  <div class="justify-center">
    @if (!!vm.list && vm.totalLength > WATCHLIST_WIDGET_MAX_ITEMS) {
      <button
        class="btn_watchlist btn btn-primary"
        (click)="openWatchlist()"
        >{{ "dashboard_watchlist_see_all" | translate }}
      </button>
    }
  </div>
</bp-tile>
